import React, { useRef } from "react";
import { useAuth } from "../../Hooks/useAuth";
import Container from "@mui/material/Container";
import { Box } from "@mui/material";

import Avatar from "@mui/material/Avatar";
import { LockOutlined } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { authenticate } from "../../API/swesum";
import {
  redirect,
  useFetcher,
  Navigate,
  useLocation,
  //useRouteError,
} from "react-router-dom";
import { Paper } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export const action =
  (login) =>
  async ({ request }) => {
    const formData = await request.formData();
    const email = formData.get("email");
    const password = formData.get("password");
    const errors = {};

    const redirectTo = formData.get("redirectTo") || "/";

    try {
      const response = await authenticate(email, password);
      const authState = {
        accessToken: "Bearer " + response.data.Token,
        username: response.data.Username,
        userType: response.data.Usertype,
        appUserID: response.data.AppUserId,
      };
      login(authState);
      if (typeof redirectTo === "string" && redirectTo.trim() !== "") {
        return redirect(redirectTo);
      }
    } catch (err) {
      errors.loginError = err.message;
      return errors;
    }
  };

export default function LoginPage() {
  const fetcher = useFetcher();
  const { authData } = useAuth();
  const formEl = useRef();
  const location = useLocation();

  if (authData?.accessToken) {
    if (authData.userType === "admin") {
      return <Navigate to="/dashboard" replace />;
    } else if (authData.userType === "client") {
      return <Navigate to="/mypages" replace />;
    }
  }

  const handleSubmit = () => {
    formEl.current && formEl.current.requestSubmit();
  };

  return (
    <Container component="main" maxWidth="false" sx={{ height: "100vh" }}>
      <Container maxWidth="xs" sx={{ pt: 15 }}>
        <Paper>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              rowGap: "25px",

              p: 2,
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlined />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <fetcher.Form method="post" action="/login" ref={formEl}>
              <Box>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Epost"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  size="small"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Lösenord"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  size="small"
                />
                {/* TO PASS LOCATION */}
                <input
                  type="hidden"
                  name="redirectTo"
                  value={location.state?.from || "/"}
                />
                <LoadingButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 4, mb: 1.5 }}
                  loading={fetcher.state === "submitting"}
                  onClick={handleSubmit}
                >
                  Logga in
                </LoadingButton>
              </Box>
            </fetcher.Form>
            <Box sx={{ m: 2 }}>
              {fetcher.data?.loginError && (
                <Typography color="error" variant="subtitle2">
                  {fetcher.data.loginError}
                </Typography>
              )}
            </Box>
          </Box>
        </Paper>
      </Container>
    </Container>
  );
}
